module.exports = __webpack_public_path__ + "static/media/rohit.3fb946b7.png";